export function debounce<T extends (...args: any[]) => void>(
  fn: T,
  delayMs: number
): (...args: Parameters<T>) => void {
  let timer: NodeJS.Timeout | null = null;
  return (...args: Parameters<T>) => {
    if (timer) {
      clearTimeout(timer);
    }
    timer = setTimeout(() => {
      timer = null;
      fn(...args);
    }, delayMs);
  };
}

export function debounceByKey<K, T extends (...args: any[]) => void>(
  fn: T,
  delayMs: number
): (key: K, ...args: Parameters<T>) => void {
  const timers = new Map<K, NodeJS.Timeout>();
  return (key: K, ...args: Parameters<T>) => {
    const existing = timers.get(key);
    if (existing) {
      clearTimeout(existing);
    }
    timers.set(
      key,
      setTimeout(() => {
        timers.delete(key);
        fn(...args);
      }, delayMs)
    );
  };
}
